import { Injectable } from '@angular/core';
import { Data, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NGXLogger } from 'ngx-logger';


@Injectable({
  providedIn: 'root'
})
export class StatusbarService {

  constructor(
    private logger: NGXLogger,
    private router: Router
  ) {
    this.logger.debug('StartusbarService activated.');

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async event => {
        this.logger.debug('Routechange detected', event);
        await this.applyRouteStyle();
      });
  }

  public async applyRouteStyle() {

    // this.logger.debug('Routechange detected: ' + this.route.snapshot.url);
    const data = this.getStateData();
    const property = 'statusbarStyle';

    this.logger.debug(data);


    if (data.hasOwnProperty(property)) {
      const style = data[property] as Style;

      this.logger.debug('Style information found: ' + style);

      return this.setStyle(style);
    }
  }

  public async setStyle(style: Style) {

    try {
      this.logger.debug('Changing StatusBar style...');
      await StatusBar.setStyle({style});
    } catch (e) {
      // Will only fail in browser, where we don't have a statusbar.
    }

  }

  private getStateData(): Data {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.data;
  }
}
